module.exports = __webpack_public_path__ + "img/poke-bowl.16121625.png";